module.exports = __webpack_public_path__ + "img/good-session-3.7901e6bf.png";